import type { Raffle } from "./types";

// Бэк отдаёт и чужие приватные — на табло только те, куда вступил.
const isVisibleOnBoard = (raffle: Raffle): boolean =>
  raffle.visibility === "open" || raffle.has_joined || raffle.is_creator;

// Сначала те, где зритель участвует, затем по пулу на убывание.
const compareBoard = (a: Raffle, b: Raffle): number =>
  Number(b.is_participant) - Number(a.is_participant) ||
  Number(b.prize_pool_usdt) - Number(a.prize_pool_usdt);

export const selectBoard = (raffles: Raffle[]): Raffle[] =>
  raffles.filter(isVisibleOnBoard).sort(compareBoard);
